const handleImageInput = (evt, actionToDispatch) => {
  if (!e && !actionToDispatch) return undefined;
  let e = evt.target.files;
  let reader = new FileReader();
  try {
    reader.readAsText(e[0]);
    reader.onload = function () {
      let attachment = {
        name: e[0].name,
        type: e[0].type,
        file: e[0]
      };
      reader.readAsDataURL(e[0]);
      reader.onload = () => {
        attachment = {...attachment, base64: reader.result};
        console.log('dispatching action');
        console.log(attachment);
        actionToDispatch(attachment);
      };
      reader.onerror = (error) => {
        console.log('Error: ', error);
        return undefined;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
      return undefined;
    };
  }
  catch (e) {
    console.log('Catch error on file reader trying');
    return undefined;
  }
};

export default handleImageInput;



// WEBPACK FOOTER //
// ./src/helpers/image/handleImageInput.js